<template>
  <button
    class="filter-button"
    :class="{ active: isActive}" 
    @click="handleClick"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'FilterButton',
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      this.$emit('clicked');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/_config.scss';

.filter-button {
  width: 100%;
  display: block;
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 3px;
  font-weight: bold;
  border: 1px solid $accent-color;
  color: $accent-color;
  transition: background-color .3s, color .3s;

  &:hover {
    background-color: $accent-color;
    color: #fff;
  }

  &.active {
    border-color: $dark-blue;
    background-color: $dark-blue;
    color: #fff;
  }
}
</style>


